import { message } from 'antd'
import axios from 'axios'
import { useCallback, useState } from 'react'

import { BASE_URL_SERVER } from '../../../ini.json'
import { LeadState } from '../../common/businessContactTypes'
import { useAppSelector } from '../../redux/hooks'

interface UseUpdateBusinessContactResult {
  updateNote: (id: string, note: string | null) => Promise<boolean>
  updateState: (id: string, state: LeadState) => Promise<boolean>
  isUpdating: boolean
}

export const useUpdateBusinessContact = (): UseUpdateBusinessContactResult => {
  const [isUpdating, setIsUpdating] = useState(false)
  const token = useAppSelector(state => state.myProfile.token)

  const updateNote = useCallback(
    async (id: string, note: string | null): Promise<boolean> => {
      if (!token) {
        message.error('Token není k dispozici')
        return false
      }

      setIsUpdating(true)

      try {
        const response = await axios.post(
          `${BASE_URL_SERVER}/api/business-contact/update/${token}`,
          { id, note }
        )

        if (response.data.success) {
          message.success('Poznámka byla úspěšně aktualizována')
          return true
        } else {
          throw new Error(
            response.data.error || 'Nepodařilo se aktualizovat poznámku'
          )
        }
      } catch (error) {
        message.error(
          error instanceof Error
            ? error.message
            : 'Nepodařilo se aktualizovat poznámku'
        )
        return false
      } finally {
        setIsUpdating(false)
      }
    },
    [token]
  )

  const updateState = useCallback(
    async (id: string, state: LeadState): Promise<boolean> => {
      if (!token) {
        message.error('Token není k dispozici')
        return false
      }

      setIsUpdating(true)

      try {
        const response = await axios.post(
          `${BASE_URL_SERVER}/api/business-contact/update/${token}`,
          { id, state }
        )

        if (response.data.success) {
          message.success('Stav byl úspěšně aktualizován')
          return true
        } else {
          throw new Error(
            response.data.error || 'Nepodařilo se aktualizovat stav'
          )
        }
      } catch (error) {
        message.error(
          error instanceof Error
            ? error.message
            : 'Nepodařilo se aktualizovat stav'
        )
        return false
      } finally {
        setIsUpdating(false)
      }
    },
    [token]
  )

  return { updateNote, updateState, isUpdating }
}
